import { render, staticRenderFns } from "./SelectFk.vue?vue&type=template&id=01e4b328"
import script from "./SelectFk.vue?vue&type=script&lang=js"
export * from "./SelectFk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports